import { makeStyles } from "@material-ui/core/styles";

export const useModalStyles = makeStyles(
  theme => ({
    borderRadius15: {
      borderRadius: "15px"
    },
    boxStylesModalLoading: {
      alignItems: "center",
      display: "flex",
      height: "100%",
      justifyContent: "center"
    },
    btnCancel: {
      "&:hover": {
        backgroundColor: theme.palette.primary.dark
      },
      backgroundColor: theme.palette.primary.dark,
      margin: "0px 10px"
    },
    btnGrpActive: {
      "&:hover": {
        backgroundColor: theme.palette.primary.main
      },
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      height: 40
    },
    btnGrpFB: {
      width: "180px"
    },
    btnGrpGM: {
      width: "230px"
    },
    btnGrpInactive: {
      "&:hover": {
        backgroundColor: "#ffffff"
      },
      backgroundColor: "#ffffff",
      color: theme.palette.primary.main,
      height: 40
    },
    btnGrpVerticalType: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center"
    },
    btnYes: {
      "&:disabled": {
        backgroundColor: "#8195ff",
        boxShadow: "none",
        opacity: 0.5
      },
      "&:hover": {
        backgroundColor: theme.palette.primary.main
      },
      backgroundColor: theme.palette.primary.main
    },
    modal: {
      minHeight: "280mpx",
      position: "relative"
    },
    modalBottom: {
      height: "40px",
      margin: "10px 0px",
      textAlign: "end"
    },
    modalCenter: {
      alignItems: "center",
      display: "flex",
      height: "calc(100% - 80px)",
      width: "100%"
    },
    modalCloseBtn: {
      position: "absolute",
      right: "20px"
    },
    modalForm: {
      height: "430px",
      padding: "0px 30px"
    },
    modalFormBody: {
      display: "grid",
      height: "250px !important"
    },
    modalFormFields: {
      padding: "0px 5px"
    },
    modalHeader: {
      height: "40px",
      width: "100%"
    },
    modalHeaderFlex: {
      alignItems: "center",
      display: "flex",
      height: "40px",
      justifyContent: "space-between",
      width: "100%"
    },
    modalTextContent: {
      fontSize: "16px",
      fontWeight: 400,
      margin: "0",
      textAlign: "center"
    },
    modalTitleContainer: {
      margin: "20px 25px"
    },
    modalTitleContainerV2: {
      margin: "20px 10px"
    },
    modalTitleText: {
      fontSize: "30px",
      fontWeight: 700,
      margin: 0,
      textAlign: "center"
    },
    modalTitleTextMargin: {
      margin: "0px 0px 15px"
    },
    modalTitleTextMedium: {
      fontSize: "20px"
    },
    modalTitleTextSmall: {
      color: "#747C8C",
      margin: "0px",
      padding: "0"
    },
    modalTitleTextV2: {
      fontSize: "23px",
      fontWeight: 700,
      margin: 0
    },
    padding0: {
      padding: "0px"
    },
    paddingTop0: {
      paddingTop: "0px !important"
    },
    switchContainer: {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      margin: "10px 10px"
    },
    switchLabel: {
      fontSize: "15.5px",
      fontWeight: 400,
      margin: "10px 0",
      textAlign: "left"
    },
    txtWhite: {
      color: "#ffffff !important"
    }
  }),
  { name: "AutoBookingModalStyles" }
);
